var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('div',{staticStyle:{"display":"flex"}},[_c('b-breadcrumb',{staticStyle:{"padding-top":"16px"},attrs:{"items":_vm.items}})],1),_vm._v(" "),(!_vm.loaded)?_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"64px"}},[_c('b-spinner')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3662b4f3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HotelDetailsJSON.vue
// module id = null
// module chunks = 